import React from 'react'
import { Autocomplete } from '@material-ui/lab'
import { Box, TextField } from '@material-ui/core'
import { IPlaceOption } from 'types/IPlaceOption'
import { IProps } from './Interface'
import useStyles from './Styles'

const PointrThemedPlacesAutocomplete: React.FC<IProps> = ({
  error,
  label,
  value,
  options,
  isLoading,
  helperText,
  searchTerm,
  placeholder,
  alwaysEnabled,
  onItemChanged,
  onInputChanged,
  disabled,
  autoFocus,
  inputRef,
  ...props
}) => {
  const classes = useStyles({ alwaysEnabled, searchTerm })

  return (
    <Box width="100%" {...props}>
      <Autocomplete
        classes={{
          root: classes.autocomplete,
          popper: classes.popper
        }}
        blurOnSelect={true}
        id="algolia-autocomplete"
        options={options}
        loading={isLoading}
        getOptionLabel={(item: IPlaceOption) => (item.state ? `${item.city}, ${item.state}` : item.city || '')}
        value={value}
        onChange={(_event: React.ChangeEvent<{}>, v: IPlaceOption) => onItemChanged(v)}
        onInputChange={(_, v: string) => onInputChanged(v)}
        inputValue={searchTerm}
        disabled={disabled}
        disableOpenOnFocus={true}
        filterOptions={filterOptions => {
          return filterOptions
        }}
        renderOption={(option: IPlaceOption) => {
          return (
            <span data-testid={`${option.id}-option`}>
              {option.state ? `${option.city}, ${option.state}` : option.city}
            </span>
          )
        }}
        renderInput={(params: any) => {
          return (
            <TextField
              {...params}
              label={label}
              classes={{
                root: classes.formControl
              }}
              InputProps={{
                ...params.InputProps,
                classes: {
                  root: classes.inputRoot
                },
                inputRef,
                autoFocus,
                className: classes.searchInput
              }}
              placeholder={placeholder}
              error={error}
              InputLabelProps={{
                shrink: true
              }}
              helperText={helperText}
            />
          )
        }}
      />
    </Box>
  )
}

PointrThemedPlacesAutocomplete.defaultProps = {
  alwaysEnabled: true,
  autoFocus: false,
  placeholder: 'Ex: New York'
}

export default PointrThemedPlacesAutocomplete
